import { ListBookDto } from '@hermes/domains'
import { authenticatedApiInstance } from '../client'
import { PaginatedApiResponse } from '../types.api'
import { Region } from '../../shared/utils/region'

export const getWishlist = (
  queryParams: {
    size?: number
    page?: number
  },
  config: { accessToken?: string; tenant?: Region } = {}
): Promise<PaginatedApiResponse<ListBookDto>> =>
  authenticatedApiInstance(config.accessToken, config.tenant)
    .get<PaginatedApiResponse<ListBookDto>>('/wishlist', { params: queryParams })
    .then((res) => res.data)

export const getWishlistBookIds = (config: { accessToken?: string; tenant?: Region } = {}): Promise<number[]> =>
  authenticatedApiInstance(config.accessToken, config.tenant)
    .get<number[]>('/wishlist', { params: { schema: 'bookId' } })
    .then((res) => res.data)

export const createWishlistItemByBookId = (
  bodyParams: { bookId: number },
  config: { accessToken?: string; tenant?: Region } = {}
) =>
  authenticatedApiInstance(config.accessToken, config.tenant)
    .post('/wishlist', bodyParams)
    .then((res) => res.data)

export const deleteWishlistItemByBookId = (
  pathParams: { bookId: number },
  config: { accessToken?: string; tenant?: Region } = {}
) =>
  authenticatedApiInstance(config.accessToken, config.tenant)
    .delete(`/wishlist/${pathParams.bookId}`)
    .then((res) => res.data)
